import { render, staticRenderFns } from "./DialogAssociaSlot.vue?vue&type=template&id=031260bf&scoped=true&"
import script from "./DialogAssociaSlot.vue?vue&type=script&lang=js&"
export * from "./DialogAssociaSlot.vue?vue&type=script&lang=js&"
import style0 from "./DialogAssociaSlot.vue?vue&type=style&index=0&id=031260bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031260bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031260bf')) {
      api.createRecord('031260bf', component.options)
    } else {
      api.reload('031260bf', component.options)
    }
    module.hot.accept("./DialogAssociaSlot.vue?vue&type=template&id=031260bf&scoped=true&", function () {
      api.rerender('031260bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogAssociaSlot.vue"
export default component.exports